import {observable, computed, action, autorun, reaction, runInAction, toJS} from 'mobx';

export class VAccessories {
  constructor(flasher, navigation, rentalObject, bestOffers, accessoriesForm, searchForm, 
    offerDetailsForm, rentalTransaction, organization, businessUnit, aggAccessories, rentalAccessoryApi, vBookingWizard) {
    this.flasher = flasher;
    this.navigation = navigation;
    this.rentalObject = rentalObject;
    this.bestOffers = bestOffers;
    this.accessoriesForm = accessoriesForm
    this.offerDetailsForm = offerDetailsForm;
    this.searchForm = searchForm;
    this.rentalTransaction = rentalTransaction;
    this.organization = organization;
    this.businessUnit = businessUnit;
    this.aggAccessories = aggAccessories;
    this.rentalAccessoryApi = rentalAccessoryApi;
    this.vBookingWizard = vBookingWizard;


    this.reactions = [];
    this.updateInProgress = false;
    this.nextUpdatePending = false;    
  }

  @computed get objId() {
    return this.rentalTransaction.refRentalObjectId;
  }

  @computed get startDate() {
    return this.offerDetailsForm.values.startDate;
  }

  @computed get endDate() {
    return this.offerDetailsForm.values.endDate;
  }  

  async startOrUpdate({orgId, trxId}, router, doNotUpdateOnChange) {
    this.vBookingWizard.setVisitedStep(3);
    try {
      this.flasher.setOther('Loading.');
      this.orgId = orgId;
      this.trxId = trxId;
      await this.rentalTransaction.cFetch({orgId, trxId});
      const objId = this.objId;
      await Promise.all([
        this.organization.cFetch({orgId}),
        this.rentalObject.cFetch({orgId, objId}),
        this.bestOffers.cFetch({
          startDate: this.rentalTransaction.realRentingStartDate,//window.sessionStorage.getItem('bwStartDate'), //this.startDate,  
          endDate: this.rentalTransaction.realRentingEndDate,//window.sessionStorage.getItem('bwEndDate'), //this.endDate, 
          organizationId: this.orgId,
          objectId: this.objId, 
          timeUnit: this.searchForm.timeUnit, 
          oldStartDate: undefined, 
          oldEndDate: undefined,
        })  
      ]);
      await this.businessUnit.cFetch({businessUnitId: this.rentalObject.businessUnitId});  
      this.resetForm(); 
      
      // TODO: Revise this...
      const startDate = this.searchForm.startDate;
      const endDate = this.searchForm.endDate; 
      this.offerDetailsForm.reset({startDate, endDate});     

      /*
      TODO: Why this was here...???

      await this.bestOffers.fetch({
        startDate: this.rentalTransaction.rentingStartDate,  
        endDate: this.rentalTransaction.rentingEndDate, 
        organizationId: this.orgId,
        objectId: objId, 
        //timeUnit: this.searchForm.timeUnit, 
        oldStartDate: undefined, 
        oldEndDate: undefined,
      });
      */

      this.stopReactions();
      if(!doNotUpdateOnChange) {
        this.reactions.push(reaction(
          () => toJS(this.accessoriesForm.dirtyValues),
          this.updateRun,
          {fireImmediately: true,} // False...?
        ));
      }
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther();      
    }    
  }

  @action.bound resetForm() {
    this.aggAccessories.joinedListing.forEach(o => {
      this.accessoriesForm.initialValues.set(o.pk, o.quantity);
      this.accessoriesForm.dirtyValues.set(o.pk, o.quantity);
    });
  }

  @action.bound initForm() { 
    this.aggAccessories.joinedListing.forEach(o => {
      this.accessoriesForm.initialValues.set(o.pk, o.quantity);      
    })
  }

  @action.bound async updateRun() {
    if(this.updateInProgress) {
      this.nextUpdatePending = true;
      return;
    }
    this.updateInProgress = true;
    try {
      do {
        this.nextUpdatePending = false;
        for(let [sid, scnt] of this.accessoriesForm.values) {
          const fromAmount = this.accessoriesForm.initialValues.get(sid);
          const toAmount = this.accessoriesForm.dirtyValues.get(sid);

          const joinedListingItem = this.aggAccessories.joinedListing.find(o => o.pk === sid);

          if(fromAmount !== toAmount) {
            if(fromAmount > 0) {

              //*-*-*-*-*
              this.flasher.setOther('Loading.');
              await this.rentalAccessoryApi.setAccessoryQuantities({
                orgId: this.orgId,
                trxId: this.trxId,
                items: [{item: joinedListingItem, quantity: toAmount}]
              })

              // !!!!!!!
              //TODO: Important: transactionOffers not joining properly!!!
              // !!!!!!!
            } else {
              //*-*-*-*-*-*
              this.flasher.setOther('Loading.');
              await this.rentalAccessoryApi.addAccessories({
                orgId: this.orgId,
                trxId: this.trxId,
                items: [{item: joinedListingItem, quantity: toAmount}]
              });
            } 
          }
        }
        this.initForm();
      } while (this.nextUpdatePending);
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.updateInProgress = false;
      this.flasher.setOther();
    }
  }

  @action.bound stop() {
    this.searchForm.stop();
    this.stopReactions();
  }

  @action.bound stopReactions() {
    this.reactions.forEach(ar => ar());
    this.reactions = [];
  }
} 


// WEBPACK FOOTER //
// ./src/view/VAccessories.js